import moment from "moment";

export const API = {
  VENDOR: {
    VENDOR_TYPES: "vendor-types",
    ADD_UPDATE_VENDOR_TYPE: "vendor-type",
    HOTEL_REGISTRATION: "hotel/hotel-vendor/registration-request",
    TRANSPORTL_REGISTRATION: "transport/transport-vendor/registration-request",
    TRANSPORT_MEET_GREET_REGISTRATION:
      "transportation-meet-greet/transportation-meet-greet-vendor/registration-request",
    SAFEGUARD_REGISTRATION: "safeguard/safeguard-vendor/registration-request",
    PORT_AGENT_REGISTRATION: "portagent/portagent-vendor/registration-request",
    TM_CENTER_REGISTRATION: "tmcenter/tmcenter-vendor/registration-request",
    SHIPBOARD_HR_REGISTRATION:
      "shipboardhr/shipboardhr-vendor/registration-request",
    MEET_GREET_REGISTRATION:
      "meet-greet/meet-greet-vendor/registration-request",
    GET_VENDOR_BY_ID: "vendor",
    UPDATE_PROFILE_IMAGE: "vendor/upload-profile-image",
    TRASNPORT_DETAILS: "transport-details",
    CREATE_TRASNPORT_DETAILS: "transport-detail",
    DELETE_TRASNPORT_DETAIL: "transport-detail",
    LIST_VENDORS: "vendors",
    UPLOAD_VEHICLE_IMAGE: "transport-detail/upload-vehicle-image",
    PORT_CRUD: "port",
    AIRPORT_CRUD: "airport",
    BRAND_CRUD: "brand",
    VEHICLE_CATEGORY_CRUD: "transport/vehicle-category",
    VEHICLE_CATEGORY_LIST: "transport/vehicle-categories",
    AMENITIES_CRUD: "amenities",
    GET_SHIPBOARD_HR: "shipboardhr/shipboardhr-vendor",
    VENDOR_PROFILE: "service-request/vendor-profile",
  },
  TRANSPORT: {
    GET_TRANSPORT_DETAILS_BY_VENDORID: "transport/transport-vendor/all-details",
    UPDATE_TRANSPORT_PROFILE_DATA_BY_VENDORID: "transport/transport-vendor",
    TRANSPORT_VEHICLE_CRUD: "transport/vehicle",
    TRANSPORT_CONTRACT_CRUD: "transport/contract",
  },
  SHIPBOARD_HR: {
    GET_TRANSPORT_DETAILS_BY_VENDORID:
      "shipboardhr/shipboardhr-vendor/all-details",
    UPDATE_SHIPBOARD_PROFILE_DATA_BY_VENDOR_ID:
      "shipboardhr/shipboardhr-vendor",
  },
  MEET_GREET: {
    GET_MEET_GREET_DETAILS_BY_VENDORID:
      "meet-greet/meet-greet-vendor/all-details",
    UPDATE_MEET_GREET_PROFILE_DATA_BY_VENDORID: "meet-greet/meet-greet-vendor",
    MEET_GREET_VEHICLE_CRUD: "meet-greet/vehicle",
    MEET_GREET_CONTRACT_CRUD: "meet-greet/contract",
  },
  TRANSPORTATION_MEET_GREET: {
    TRANSPORTATION_GET_MEET_GREET_DETAILS_BY_VENDORID:
      "transportation-meet-greet/transportation-meet-greet-vendor/all-details",
    TRANSPORTATION_UPDATE_MEET_GREET_PROFILE_DATA_BY_VENDORID:
      "transportation-meet-greet/transportation-meet-greet-vendor",
    TRANSPORTATION_MEET_GREET_VEHICLE_CRUD: "transportation-meet-greet/vehicle",
    TRANSPORTATION_MEET_GREET_CONTRACT_CRUD:
      "transportation-meet-greet/contract",
  },
  HOTEL: {
    GET_HOTEL_DETAILS_BY_VENDORID: "hotel/hotel-vendor/all-details",
    UPDATE_DATA_BY_VENDORID: "hotel/hotel-vendor",
    HOTEL_DETAILS: "hotel-detail/vendor",
    CREATE_UPDATE: "hotel-detail/updateOrCreate",
    HOTEL_DETAIL_BY_ID: "hotel-detail",
    HOTEL_CONTACTS_BY_ID: "contact/hotel",
    HOTEL_CONTACTS_CREATE_UPDATE: "hotel/contact/updateOrCreate",
    HOTEL_ROOMS_CREATE_UPDATE: "hotel/hotel-room/updateOrCreate",
    HOTE_MEAL_ALLOWANCE_CREATE_UPDATE: "hotel/meal-allowance/updateOrCreate",
    CREATE_HOTEL_DETAIL: "hotel-detail",
    DELETE_HOTEL_DETAIL: "hotel-detail",
    UPLOAD_HOTEL_IMAGE: "hotel-detail/upload-hotel-image",
    HOTEL_CONTACTS_DELETE: "hotel/contact/delete/",
    HOTEL_ROOM_DELETE: "hotel/hotel-room/delete/",
    HOTEL_MEAL_ALLOWANCE_DELETE: "hotel/meal-allowance/",
    GET_HOTEL_SERVICE_REQUEST_BY_VENDOR_ID: "hotel-service-requests",
    PAST_CHECKIN_SCANS: "hotel-vendor/past-scans/check-ins",
    PAST_MEAL_SCANS: "hotel-vendor/past-scans/meals",
    GET_SHUTTLE_SERVICE: "hotel/hotel-vendor/hotel-shuttle-support",
    GET_VENDOR_EMPLOYEES: "hotel/hotel-vendor/employees",
  },
  AUTH: {
    LOGIN: "auth/login",
    LOGOUT: "auth/logout",
    ENTRA_CALLBACK: "auth/entra-callback",
    CHANGE_PASSWORD: "auth/change-password",
    REFRESH_AUTH_TOKENS: "auth/refresh-auth-tokens",
    FORGOT_PASSWORD: "auth/forgot-password",
    FORGOT_PASSWORD_CONFIRM: "auth/forgot-password-confirm",
  },
  ADMIN: {
    APPROVE_REGISTRATION_REQUEST: "admin/approve-registration-request",
    LIST_CARNIVAL_ADMINS: "carnival-admins",
    CREATE_CARNIVAL_ADMIN: "admin/create-carnival-admin",
    LIST_ARRIVALS_AND_DEPARTURE: "tmhub-proxy/list-tms",
  },
  REGISTRATION_REQUEST: {
    LIST: `hotel/hotel-vendor/registration-requests`,
    COUNT: `hotel/hotel-vendor/registration-request-count`,
    UPLOAD_PROFILE_IMAGE: "registration-request/upload-profile-image/",
  },
  CARNIVAL_ADMIN: {
    LIST_SERVICE_REQUESTS: "service-requests",
    CREATE_SERVICE_REQUEST: "service-request",
    REMOVE_SERVICE_REQUEST: "service-request/remove-multiple",
    GET_SERVICE_REQUEST_BY_VENDOR_ID: "service-requests",
  },
  CREATE_EMPLOYEE: "vendor-employee",
  DELETE_EMPLOYEE: "vendor-employee/delete",
  LIST_VENDOR_EMPLOYEE: "vendor-employee",
  LIST_EMPLOYEE: "vendor-employees",
  VENDOR_USER_LIST: {
    Transportation: "transport/transport-vendors",
    Safeguard: "safeguard/safeguard-vendors",
    "Meet & Greet": "transport/transport-vendors",
    "Transportation & Meet/Greet":
      "transportation-meet-greet/transportation-meet-greet-vendors",
  },
  VENDOR_SERVICE_REQUEST: {
    SHIPBOARD_HR_ARRIVED: "shipboardhr-service-request",
    CREATE_MANUAL_REQUEST: "create-manual-request",
  },
  NOTIFICATIONS: {
    CREATE: "notification/notification-request",
    GET: "notifications",
    UPDATE: "notification",
  },
  FINANCE_ALERTS: {
    LIST: "notification/finance/alerts",
    SUMMARY: "notification/finance/alerts/summary",
    SUPER_ADMIN_RECIPIENT_ID: "SUPER_ADMIN",
    PAGE_SIZE: 50,
    POLL_INTERVAL_MS: 60_000,
    buildReadUrl: (id: string): string =>
      `notification/finance/alerts/${encodeURIComponent(id)}/read`,
  },
  INVOICE: {
    INVOICE_DETAILS_FN_SQL:
      "SELECT * FROM auto_invoicing.fn_get_invoice_details_v2( $1 );",
    USE_BEDROCK_INVOICES: true,
    USE_EXECUTE_QUERY_HEADER: true,
    EXECUTE_QUERY: "bedrock-db-test/execute-query",
    CREATE: "invoice/invoice-request",
    LIST: "mock/invoice/list",
    PENDING_SERVICE_SCANS: "service-requests/pending",
    PENDING_MEAL_SCANS: 'hotel-service-requests/pending',
    UPDATE_VENDOR_INVOICE_ID: "v1/bedrock/invoicing/invoices/update-invoice-number",
    CREATE_MANUAL: "v1/bedrock/invoicing/invoices/manual-entry",

    LIST_BEDROCK: "v1/bedrock/invoicing/invoices",

    LIST_WINDOW_DAYS_MAX: 180,

    resolveListWindow: (days: number): { startDate: string; endDate: string } => ({
      startDate: moment().subtract(days, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }),
    buildBedrockListUrl: (params: {
      startDate: string;
      endDate: string;
      vendorId?: string;
    }): string => {
      const query = new URLSearchParams({
        startDate: params.startDate,
        endDate: params.endDate,
      });
      if (params.vendorId) {
        query.set("vendorId", params.vendorId);
        return `v1/bedrock/invoicing/vendor/invoices?${query.toString()}`;
      }
      return `v1/bedrock/invoicing/invoices?${query.toString()}`;
    },
    buildBedrockLineItemsUrl: (invoiceId: string): string =>
      `v1/bedrock/invoicing/invoices/${encodeURIComponent(invoiceId)}/line-items`,
    VENDOR_SCOPED_INVOICES:
      process.env.REACT_APP_ENABLE_VENDOR_SCOPED_INVOICES === "true",
    DETAIL: "v1/bedrock/invoicing/invoices",
    UPDATE_STATUS: "mock/invoice/update-status",
    REJECT: "mock/invoice/reject",
    SUBMIT: "mock/invoice/submit",
    UPDATE_RATES: "mock/invoice/update-rates",
    UPDATE_INVOICE_NUMBER: "v1/bedrock/invoicing/invoices/update-invoice-number",
    buildBedrockApproveUrl: (invoiceId: string | number): string =>
      `v1/bedrock/invoicing/invoices/${encodeURIComponent(String(invoiceId))}/approve`,
    buildBedrockRejectUrl: (invoiceId: string | number): string =>
      `v1/bedrock/invoicing/invoices/${encodeURIComponent(String(invoiceId))}/reject`,
    buildBedrockRegenerateUrl: (invoiceId: string | number): string =>
      `v1/bedrock/invoicing/invoices/${encodeURIComponent(String(invoiceId))}/regenerate`,
    REJECTION_REASONS: "v1/bedrock/invoicing/invoices/rejection-reasons",
  },
  USER_LOCATION: {
    LIST_TMS_LOC: "user-locations",
    GREETER_LOCATIONS: "user-location/greeter/locations",
  },
  UNLISTED_TM_SCANS: {
    GET_UNLISTED_TM_SCANS: "assignment-approvals",
    ASSIGNMENT_APPROVAL: "assignment-approval",
  },
  EXPORT: {
    CSV_ASSIGNMENTS_AND_SCANS: "export/csv/assignments-and-scans",
  },
  MANUAL_SCAN: {
    TRANSPORT: 'service-request/manual/create',
    MEAL: 'hotel-service-request/manual/create',
  }
};
